var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0a12ff99"), n = n(), _popScopeId(), n);
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "p-5" };
const _hoisted_3 = { class: "columns is-variable is-5" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "column is-narrow" }, [
    /*#__PURE__*/ _createElementVNode("h1", { class: "subtitle mb-4" }, "Analytics"),
    /*#__PURE__*/ _createElementVNode("h3", null, "Data and insights on citizens assisted")
], -1));
const _hoisted_5 = { class: "ml-5 is-flex is-flex-direction-row is-flex-grow-1" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "column" }, null, -1));
const _hoisted_7 = { class: "columns" };
const _hoisted_8 = {
    key: 1,
    class: "p-5 summaryRow"
};
const _hoisted_9 = { class: "columns" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "column p-0" }, null, -1));
const _hoisted_11 = { class: "columns p-5" };
const _hoisted_12 = { class: "graphWrapper card" };
const _hoisted_13 = { class: "level is-narrow" };
const _hoisted_14 = { class: "graphTitle" };
const _hoisted_15 = { class: "graphTopRight" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-file-download" }, null, -1));
const _hoisted_17 = [
    _hoisted_16
];
const _hoisted_18 = { class: "columns p-5" };
const _hoisted_19 = { class: "graphWrapper card" };
const _hoisted_20 = { class: "level is-narrow" };
const _hoisted_21 = { class: "graphTitle" };
const _hoisted_22 = { class: "graphTopRight" };
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-file-download" }, null, -1));
const _hoisted_24 = [
    _hoisted_23
];
const _hoisted_25 = { class: "columns p-5" };
const _hoisted_26 = { class: "graphWrapper card" };
const _hoisted_27 = { class: "level is-narrow" };
const _hoisted_28 = { class: "graphTitle" };
const _hoisted_29 = { class: "graphTopRight" };
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-file-download" }, null, -1));
const _hoisted_31 = [
    _hoisted_30
];
import { useAsync } from "@/composables/useAsync";
import { canSeeFeature, isNetworkAdmin, sessionState } from "@/core/session";
import { enumKey } from "@/core/utils";
import { onMounted, ref, watch } from "vue";
import { apiCitizenAnalytics } from "./api";
import { ApplicationType, CitizenDimension, CitizenMeasure, Granularity, getCurrentPeriodNameForGranularity, Program } from "./model";
import FormSelectField from "@/components/FormSelectField.vue";
import BarChart from "./BarChart.vue";
import LineChart from "./LineChart.vue";
import MetricSummaryCard from "./MetricSummaryCard.vue";
import PieChart from "./PieChart.vue";
import { doApiAction } from "@/core/api";
import PartnerSelectField from "@/features/partners/PartnerSelectField.vue";
// UI State
export default /*#__PURE__*/ _defineComponent({
    __name: 'CitizenAnalyticsPanel',
    setup(__props) {
        const partnerId = ref(null);
        const programId = ref(null);
        const granularity = ref(Granularity["By Month"]);
        const measure = ref(CitizenMeasure["Citizens Registered"]);
        const dimension = ref(CitizenDimension["By Age"]);
        const applicationType = ref(ApplicationType["Birth Records"]);
        const summary = useAsync();
        const historyChart = useAsync();
        const groupChart = useAsync();
        const applicationsChart = useAsync();
        const inProgressAction = ref(null);
        const reloadSummaryCards = () => {
            summary.fetch(apiCitizenAnalytics.getSummary(partnerId.value, programId.value, granularity.value), "Failed to load summary data");
        };
        const reloadHistoryChart = () => {
            historyChart.fetch(apiCitizenAnalytics.getCitizenCountHistory(partnerId.value, programId.value, granularity.value, measure.value), "Failed to load citizen history data");
        };
        const reloadGroupChart = () => {
            groupChart.fetch(apiCitizenAnalytics.getGroupedCitizenCounts(partnerId.value, programId.value, granularity.value, measure.value, dimension.value)
                // Extract the most recent value from each group
                .then(groupedData => groupedData.groups
                .map(group => ({ label: group.name, value: group.values[group.values.length - 1] }))
                .filter(dataPoint => dataPoint.value != 0)), "Failed to load citizen group data");
        };
        const reloadApplicationsChart = () => {
            applicationsChart.fetch(apiCitizenAnalytics.getApplicationStatusHistory(partnerId.value, programId.value, granularity.value, applicationType.value), "Failed to load application status history data");
        };
        const reloadAllCharts = () => {
            reloadSummaryCards();
            reloadHistoryChart();
            reloadGroupChart();
            reloadApplicationsChart();
        };
        const downloadChart = (promise) => {
            doApiAction(inProgressAction, "downloadCsv", null, "Failed to download CSV", () => __awaiter(this, void 0, void 0, function* () {
                yield promise.then((csvViewLink) => window.open(csvViewLink));
            }));
        };
        const downloadHistoryChart = () => {
            downloadChart(apiCitizenAnalytics.getCitizenCountHistoryCsvViewLink(partnerId.value, programId.value, granularity.value, measure.value));
        };
        const downloadGroupChart = () => {
            downloadChart(apiCitizenAnalytics.getGroupedCitizenCountsCsvViewLink(partnerId.value, programId.value, granularity.value, measure.value, dimension.value));
        };
        const downloadApplicationsChart = () => {
            downloadChart(apiCitizenAnalytics.getApplicationStatusHistoryCsvViewLink(partnerId.value, programId.value, granularity.value, applicationType.value));
        };
        onMounted(() => {
            // Fetch analytics from API
            if (sessionState.session) {
                partnerId.value = sessionState.session.partnerId;
                reloadAllCharts();
            }
        });
        watch([partnerId, granularity, programId], () => {
            reloadAllCharts();
        });
        watch(measure, () => {
            reloadHistoryChart();
            reloadGroupChart();
        });
        watch(dimension, () => {
            reloadGroupChart();
        });
        watch(applicationType, () => {
            reloadApplicationsChart();
        });
        return (_ctx, _cache) => {
            const _component_LoadingPage = _resolveComponent("LoadingPage");
            return (_unref(canSeeFeature)('analytics'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(FormSelectField, {
                                    class: "is-narrow",
                                    label: "Program",
                                    modelValue: programId.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((programId).value = $event)),
                                    options: _unref(Program),
                                    allowNullSelection: "",
                                    nullSelectionLabel: "-- All --"
                                }, null, 8, ["modelValue", "options"]),
                                (_unref(isNetworkAdmin)())
                                    ? (_openBlock(), _createBlock(PartnerSelectField, {
                                        key: 0,
                                        modelValue: partnerId.value,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((partnerId).value = $event)),
                                        allowSelectAll: ""
                                    }, null, 8, ["modelValue"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _hoisted_6,
                            _createVNode(FormSelectField, {
                                class: "is-narrow",
                                label: "Time Period",
                                modelValue: granularity.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((granularity).value = $event)),
                                options: _unref(Granularity)
                            }, null, 8, ["modelValue", "options"])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            (_unref(summary).status == 'loading')
                                ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
                                : (_unref(summary).status == 'ready')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        _createVNode(MetricSummaryCard, {
                                            label: `Citizens Registered ${_unref(getCurrentPeriodNameForGranularity)(granularity.value)}`,
                                            metric: _unref(summary).data.citizensRegistered
                                        }, null, 8, ["label", "metric"]),
                                        (_unref(canSeeFeature)('birthRecords'))
                                            ? (_openBlock(), _createBlock(MetricSummaryCard, {
                                                key: 0,
                                                label: `Birth Records Requested ${_unref(getCurrentPeriodNameForGranularity)(granularity.value)}`,
                                                metric: _unref(summary).data.birthRecordsRequested
                                            }, null, 8, ["label", "metric"]))
                                            : _createCommentVNode("", true),
                                        (_unref(canSeeFeature)('socialSecurity'))
                                            ? (_openBlock(), _createBlock(MetricSummaryCard, {
                                                key: 1,
                                                label: `Social Security Cards Requested ${_unref(getCurrentPeriodNameForGranularity)(granularity.value)}`,
                                                metric: _unref(summary).data.socialSecurityRequested
                                            }, null, 8, ["label", "metric"]))
                                            : _createCommentVNode("", true),
                                        (_unref(canSeeFeature)('georgiaBenefits'))
                                            ? (_openBlock(), _createBlock(MetricSummaryCard, {
                                                key: 2,
                                                label: `Georgia Benefits Requested ${_unref(getCurrentPeriodNameForGranularity)(granularity.value)}`,
                                                metric: _unref(summary).data.georgiaDfcsBenefitsRequested
                                            }, null, 8, ["label", "metric"]))
                                            : _createCommentVNode("", true),
                                        (_unref(canSeeFeature)('georgiaBenefits'))
                                            ? (_openBlock(), _createBlock(MetricSummaryCard, {
                                                key: 3,
                                                label: `Estimated Value Of Benefits ${_unref(getCurrentPeriodNameForGranularity)(granularity.value)}`,
                                                metric: _unref(summary).data.esimtatedBenefitsValue,
                                                prefixUnit: "$"
                                            }, null, 8, ["label", "metric"]))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _hoisted_10,
                            _createVNode(FormSelectField, {
                                class: "is-narrow",
                                label: "Statistic",
                                modelValue: measure.value,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((measure).value = $event)),
                                options: _unref(CitizenMeasure)
                            }, null, 8, ["modelValue", "options"])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(enumKey)(measure.value, _unref(CitizenMeasure))) + " " + _toDisplayString(_unref(enumKey)(granularity.value, _unref(Granularity))), 1),
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("a", {
                                            class: _normalizeClass(["button is-link", { 'is-loading': inProgressAction.value == 'downloadCsv' }]),
                                            onClick: _cache[4] || (_cache[4] = ($event) => (downloadHistoryChart()))
                                        }, _hoisted_17, 2)
                                    ])
                                ]),
                                (_unref(historyChart).status == 'loading')
                                    ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
                                    : (_unref(historyChart).status == 'ready')
                                        ? (_openBlock(), _createBlock(LineChart, {
                                            key: 1,
                                            data: _unref(historyChart).data
                                        }, null, 8, ["data"]))
                                        : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(enumKey)(measure.value, _unref(CitizenMeasure))) + " " + _toDisplayString(_unref(getCurrentPeriodNameForGranularity)(granularity.value)) + " " + _toDisplayString(_unref(enumKey)(dimension.value, _unref(CitizenDimension))), 1),
                                    _createElementVNode("div", _hoisted_22, [
                                        _createVNode(FormSelectField, {
                                            modelValue: dimension.value,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((dimension).value = $event)),
                                            options: _unref(CitizenDimension)
                                        }, null, 8, ["modelValue", "options"]),
                                        _createElementVNode("a", {
                                            class: _normalizeClass(["button is-link", { 'is-loading': inProgressAction.value == 'downloadCsv' }]),
                                            onClick: _cache[6] || (_cache[6] = ($event) => (downloadGroupChart()))
                                        }, _hoisted_24, 2)
                                    ])
                                ]),
                                (_unref(groupChart).status == 'loading')
                                    ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
                                    : (_unref(groupChart).status == 'ready')
                                        ? (_openBlock(), _createBlock(PieChart, {
                                            key: 1,
                                            data: _unref(groupChart).data
                                        }, null, 8, ["data"]))
                                        : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(enumKey)(applicationType.value, _unref(ApplicationType))) + " Application Status " + _toDisplayString(_unref(enumKey)(granularity.value, _unref(Granularity))), 1),
                                    _createElementVNode("div", _hoisted_29, [
                                        _createVNode(FormSelectField, {
                                            class: "is-narrow",
                                            modelValue: applicationType.value,
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((applicationType).value = $event)),
                                            options: _unref(ApplicationType)
                                        }, null, 8, ["modelValue", "options"]),
                                        _createElementVNode("a", {
                                            class: _normalizeClass(["button is-link", { 'is-loading': inProgressAction.value == 'downloadCsv' }]),
                                            onClick: _cache[8] || (_cache[8] = ($event) => (downloadApplicationsChart()))
                                        }, _hoisted_31, 2)
                                    ])
                                ]),
                                (_unref(applicationsChart).status == 'loading')
                                    ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
                                    : (_unref(applicationsChart).status == 'ready')
                                        ? (_openBlock(), _createBlock(BarChart, {
                                            key: 1,
                                            data: _unref(applicationsChart).data
                                        }, null, 8, ["data"]))
                                        : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
